import { routePaths } from "../../../../routes/navigation";

export type RetailCockpitView =
    | "overview"
    | "stores"
    | "turnover"
    | "last-sale"
    | "groups"
    | "nomenclature"
    | "clients"
    | "avg-ticket"
    | "avg-items"
    | "flow"
    | "hourly-revenue"
    | "defects"
    | "pricing"
    | "promotions";

export const retailCockpitViewLabels: Record<RetailCockpitView, string> = {
    overview: "Общ преглед",
    stores: "По магазини",
    turnover: "Продажби общо",
    "last-sale": "Последна продажба",
    groups: "Стокови групи",
    nomenclature: "Номенклатури",
    clients: "Клиенти",
    "avg-ticket": "Средна касова бележка",
    "avg-items": "Средно артикули в една касова бележка",
    flow: "Клиентски поток",
    "hourly-revenue": "Оборот по часове",
    defects: "Брак и отписи",
    pricing: "Редовна / преоценка",
    promotions: "Акции",
};

/** Кратки етикети за компактни редове. */
export const retailCockpitViewShortLabels: Record<RetailCockpitView, string> = {
    overview: "Обобщение",
    stores: "Магазини",
    turnover: "Продажби",
    "last-sale": "Последна",
    groups: "Групи",
    nomenclature: "Номенклатури",
    clients: "Клиенти",
    "avg-ticket": "Бележка",
    "avg-items": "Артикули",
    flow: "Поток",
    "hourly-revenue": "Часове",
    defects: "Брак",
    pricing: "Преоценка",
    promotions: "Акции",
};

const COCKPIT_VIEWS = new Set<string>(Object.keys(retailCockpitViewLabels));

/** Скрити табове — дублират отделен екран (виж routePaths.retailFrequency). */
const HIDDEN_COCKPIT_VIEWS = new Set<RetailCockpitView>(["flow"]);

/** Магазини - Продажби - табовте .Два реда табове — основни изгледи и детайлни анализи. */
export const retailCockpitViewRowLabels = ["Основни", "Детайли"] as const;

export const retailCockpitViewRows: RetailCockpitView[][] = [
    [
        "overview",
        "stores",
        "turnover",
        "hourly-revenue",
        "last-sale",
        "groups",
        "nomenclature",
    ],
    [
        "clients",
        "avg-ticket",
        "avg-items",
        "defects",
        "pricing",
        "promotions",
    ],
];

export const retailCockpitTabViews: RetailCockpitView[] = retailCockpitViewRows.flat();

export function parseRetailCockpitView(value: string | null): RetailCockpitView {
    if (value === "flow" || value === "store-compare") {
        return "overview";
    }

    if (value && COCKPIT_VIEWS.has(value) && !HIDDEN_COCKPIT_VIEWS.has(value as RetailCockpitView)) {
        return value as RetailCockpitView;
    }

    return "overview";
}

export function buildRetailCockpitHref(view: RetailCockpitView): string {
    if (view === "overview") {
        return routePaths.retailCockpit;
    }

    const params = new URLSearchParams();
    params.set("view", view);

    return `${routePaths.retailCockpit}?${params.toString()}`;
}
